import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import FilaResultado from "./tablaResultados/FilaResultado";

class TablaResultados extends Component {
  render() {
    return (
      <Table selectable style={{ cursor: "pointer" }}>
        <Table.Body>
          {Object.values(this.props.opciones).map(item => (
            <FilaResultado
              key={item}
              idAccion={this.props.idAccion}
              resultado={item}
              handleCambiarResultado={this.props.cambiarResultado}
            />
          ))}
        </Table.Body>
      </Table>
    );
  }
}

export default TablaResultados;



// WEBPACK FOOTER //
// ./src/pages/ventas/ventas/tablaColegios/filaColegios/tablaAcciones/filaAcciones/TablaResultados.jsx